
import { IS_DETECT_LOADING } from "@/employee/components/state/actions/isChange";
import { store } from "@/web/components/state/store";
import { GetUserInfo, setIsLogin, SetUserInfo } from "@/employee/components/state/actions/login";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc); 
dayjs.extend(timezone);

export const checkTimeZone = (timeZoneOffset) => {
    let user = GetUserInfo() //store.getState().userInfStateReducer;
    if(timeZoneOffset) {
        if(isFinite(parseFloat(timeZoneOffset))) {
            store.dispatch(setIsLogin(null));
            store.dispatch(SetUserInfo({}));
            setTimeout(() => {
                // window.location.href = "/";
            }, 300);

            console.error('Invalid timeZoneOffset:', timeZoneOffset);
            return true;
        }
    } else if(timeZoneOffset === null || timeZoneOffset === undefined || timeZoneOffset === "") {
        let siteIdCurrent = user && user.userInfo && user.userInfo.siteIdCurrent ? user.userInfo.siteIdCurrent : null
        let timeZoneOffset = siteIdCurrent && siteIdCurrent.timeZone ? siteIdCurrent.timeZone : "";
        if(user && user.isLogin) {
            if (timeZoneOffset === null || timeZoneOffset === undefined || timeZoneOffset === "" || isFinite(parseFloat(timeZoneOffset))) {
                store.dispatch(setIsLogin(null));
                store.dispatch(SetUserInfo({}));
                setTimeout(() => {
                    // window.location.href = "/";
                }, 300);

                console.error('Invalid timeZoneOffset:', timeZoneOffset);
                return true;
            }
        }
    }
};

export const formatDateCenterZone = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset);
    return timeDate.format('dddd MMM DD YYYY HH:mm');
};

export const formatDate = date => {
    return dayjs(date).format('YYYY-MM-DD');
}
export const formatDateSecondary = date => {
    return dayjs(date).format('MM/DD/YYYY');
}
export const formatDateCenter = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset);
    return timeDate.format('dddd MMM DD YYYY HH:mm');
};
export const formatDateCenterisSameDay = (date, timeZoneOffset) => {
    if (!dayjs.isDayjs(date)) {
        date = dayjs(date);
    }
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? date.tz(timeZoneOffset) : date.utcOffset(timeZoneOffset);
    if (!timeDate || typeof timeDate.format !== 'function') {
        return null;
    }
    return timeDate.format('MM/DD/YYYY');
};
export const formatDateCenterNew = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset);
    return timeDate.format('MM/DD/YYYY HH:mm:ss');
};

export const formatDateCenterDay = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ?  dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset);
    let dateNew =  new Date(formatDateTimekkk(timeDate));
    return dateNew
};

export const formatDateTimekkk = date => {
    return dayjs(date).format('YYYY-MM-DD  h:mm:ss');
}
export const formartDateMDY24hr = date => {
    return dayjs(date).format('MM/DD/YYYY HH:mm:ss');
}
export const formartDateMDY24hrNoSecond = date => {
    return dayjs(date).format('MM/DD/YYYY HH:mm');
}
export const formatDateTimes = date => {
    return dayjs(date).format('YYYY-MM-DD  h:mm a');
}
export const formatDateTimeSlas = date => {
    return dayjs(date).format('MM/DD/YYYY  h:mm a');
}
export const formatDateTimeSlasMDY = date => {
    return dayjs(date).format('MM/DD/YYYY  h:mm a');
}
export const formatDateTimeSlasMDYAM = date => {
    return dayjs(date).format('MM/DD/YYYY  h:mm A');
}
export const formatDateTimeCurentNewAM = date => {
    return dayjs(date).format('h:mm A')
}
export const formatDateTimeSlasMDYY = (date, countMonth) => {
    return dayjs(date).format('MMM.DD YYYY');
}
export const formatDateTimeSlasMYY = (date, countMonth, addDay) => {
    if(addDay) {
        let addMonths = dayjs(date).add(countMonth, 'M').format('MM/DD/YYYY');
        return dayjs(addMonths).add(addDay ? addDay : 0, 'days').format('MM/DD/YYYY 00:00:00');
    }
    else if(countMonth) {
        return dayjs(date).add(countMonth, 'M').format('MMM, YYYY');
    } else {
        return dayjs(date).format('MMM, YYYY');
    }
}
export const formatDateTimeSlasMYYs = (date, countMonth, addDay) => {
    if(countMonth) {
        let addMonths = dayjs(date).add(countMonth, 'M').format('MM/DD/YYYY');
        return dayjs(addMonths).add(addDay ? addDay : 0, 'days').format('MM/DD/YYYY');
    } else {
        return dayjs(date).format('MM/DD/YYYY');
    }
}

export const formatDateTimeSlasMYYsDayH = (date, countMonth=0, addDay=0, addHour=0) => {
    return dayjs(date)
    .add(countMonth, 'month')
    .add(addDay ? addDay : 0, 'days')
    .add(addHour, 'hour')
    .format('MM/DD/YYYY HH:mm');
}


export const formatDateTimeSlasMYYSpace = (date, countMonth, addDay) => {
    if(countMonth) {
        let addMonths = dayjs(date).add(countMonth, 'M').format('MM / DD / YYYY');
        return dayjs(addMonths).add(addDay ? addDay : 0, 'days').format('MM / DD / YYYY');
    } else {
        return dayjs(date).format('MM / DD / YYYY');
    }
}

export const formatDateTimeAddDay = (date, addDay) => {
    return dayjs(date).add(addDay, 'd').format('YYYY-MM-DD  h:mm a');
}
export const formatDateTimeYYYY = (date, countY) => {
    if(countY) {
        return dayjs(date).add(countY, 'years').format('YYYY');
    } else {
        return dayjs(date).format('YYYY');
    }
}
export const formatDateTimeCurent = (date, time) => {
    const today = dayjs(date).format('YYYY-MM-DD h:mm a')
    const todayStr = `${today}`
    let str = time ? todayStr.slice(-8) : todayStr
    let strNew = todayStr.replace(str, ` ${time}`)
    return dayjs(strNew).local("en")
}
export const formatDateTimeCurentNew = date => {
    return dayjs(date).format('h:mm a')
}

export const formatDateTimeCurentCalendar = (date, time) => {
    const today = dayjs(date).format('YYYY-MM-DD h:mm a')
    const todayStr = `${today}`
    let str = time ? todayStr.slice(-8) : todayStr
    let strNew = todayStr.replace(str, ` ${time}`)
    date =  dayjs(strNew).local("en")
    return dayjs(date).format('H:mm')
}

export const formatDateTimeSlasSpace = date => {
    return (
        <>
        <span>{dayjs(date).format('MM/DD/YYYY')}</span>&nbsp;&nbsp;
        <span>{dayjs(date).format('h:mm a')}</span>
        </>
    )
}

export const formatDateTimeSlasSpaceMMDDYYFullTime = date => {
    return (
        <>
        <span>{dayjs(date).format('MM/DD/YYYY')}</span>&nbsp;&nbsp;
        <span>{dayjs(date).format(' hh:mm:ss a')}</span>
        </>
    )
}

export const formatDateTimeMMDDYYFullTime2Line = date => {
    return (
        <>
        <p className="d-flex mb-1">{dayjs(date).format('MM/DD/YYYY')}</p>
        <p className="d-flex mb-1">{dayjs(date).format(' hh:mm:ss a')}</p>
        </>
    )
}

export const formatDateTimeMMDDYYFullTimedate = date => {
    return (
        <>
        <p className="d-flex mb-1">{dayjs(date).format("MM/DD/YYYY hh:mm:ss a")}</p>
        </>
    )
}

export const formatDateTimeSlasSpaceMMDDYY = date => {
    return (
        <>
        <span>{dayjs(date).format('MM/DD/YYYY')}</span>&nbsp;&nbsp;
        <span>{dayjs(date).format('h:mm a')}</span>
        </>
    )
}

export const formatDateTimeSlasSpaceMMDDYYUpperCase = date => {
    return (
        <>
        <span>{dayjs(date).format('MM/DD/YYYY')}</span>&nbsp;&nbsp;
        <span>{dayjs(date).format('h:mm a').toUpperCase()}</span>
        </>
    )
}

export const formatDateTimeSlasNoSpaceMMDDYYUpperCase = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset)
    return (
        <>
        <span>{timeDate.format('MM/DD/YYYY')}</span>&nbsp;&nbsp;
        <span>{timeDate.format('h:mm a').toUpperCase()}</span>
        {timeZoneOffset ? <span className="ms-2">(UTC{timeZoneOffset}) </span> : ""}
        </>
    )
}
export const formatDateTimeSlasNoSpaceMMDDYYZone = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset)
    return (
        <>
        <span>{timeDate.format('MMM DD, YYYY')}</span>&nbsp;&nbsp;
        {/* <span>{timeDate.format('h:mm a').toUpperCase()}</span> */}
        {/* {timeZoneOffset ? <span className="ms-2">(UTC{timeZoneOffset}) </span> : ""} */}
        </>
    )
}
export const formatDateTimeSlasNoSpaceMMDDYYUpperCaseZone = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset)
    return (
        <>
        <span>{timeDate.format('MM/DD/YYYY')}</span>&nbsp;&nbsp;
        {/* <span>{timeDate.format('h:mm a').toUpperCase()}</span> */}
        {/* {timeZoneOffset ? <span className="ms-2">(UTC{timeZoneOffset}) </span> : ""} */}
        </>
    )
}
export const formatDateTimeZone = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset)
    return timeDate.format('MM/DD/YYYY')
}
export const formatDateDayZone = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset)
    return (
        <>
        <span>{timeDate.format('dddd MMM DD YYYY h:mm A')}</span>&nbsp;&nbsp;
        {/* <span>{timeDate.format('h:mm a').toUpperCase()}</span> */}
        {/* {timeZoneOffset ? <span className="ms-2">(UTC{timeZoneOffset}) </span> : ""} */}
        </>
    )
}
export const formatDateTimeSlasNoSpaceMMDDYYUpperCaseZoneTimeHH = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset)
    return (
        <>
        {/* <span>{timeDate.format('MM/DD/YYYY')}</span>&nbsp;&nbsp; */}
        <span>{timeDate.format('HH:mm:ss').toUpperCase()}</span>
        {/* {timeZoneOffset ? <span className="ms-2">(UTC{timeZoneOffset}) </span> : ""} */}
        </>
    )
}
export const formatDateTimeSlasNoSpaceMMDDYYUpperCaseZoneTime = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset)
    return (
        <>
        {/* <span>{timeDate.format('MM/DD/YYYY')}</span>&nbsp;&nbsp; */}
        <span>{timeDate.format('h:mm').toUpperCase()}</span>
        {/* {timeZoneOffset ? <span className="ms-2">(UTC{timeZoneOffset}) </span> : ""} */}
        </>
    )
}

export const formatDateTimeSlasNoSpaceMMDDYYUpperCaseZoneTimeTT = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;

    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset);
    return (
        <> 
            {/* <span>{timeDate.format('MM/DD/YYYY')}</span>   */}
            <span>{timeDate.format('h:mm ')}</span>
            <span style={{ opacity: 0.3 }}>{timeDate.format('A').toUpperCase()}</span>
            {/* {timeZoneOffset ? <span className="ms-2">(UTC{timeZoneOffset}) </span> : ""} */}
        </>
    );
};

export const formatDateTimeSlasNoSpaceMMDDYYUpperCaseZoneType = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset)
    return (
        <>
        {/* <span>{timeDate.format('MM/DD/YYYY')}</span>&nbsp;&nbsp; */}
        <span>{timeDate.format('a').toUpperCase()}</span>
        {/* {timeZoneOffset ? <span className="ms-2">(UTC{timeZoneOffset}) </span> : ""} */}
        </>
    )
}

export const formatDateTimeSlasSpaceFullTime = date => {
    return (
        <>
        <span>{dayjs(date).format('YYYY-MM-DD')}</span>&nbsp;&nbsp;
        <span>{dayjs(date).format(' H: mm')}</span>
        </>
    )
}

export const formatDateTimeDay = date => {
    return dayjs(date).format('DD/MM/YYYY');
}
export const formatDateTime = date => {
    return dayjs(date).format('YYYY-MM-DD  hh:mm:ss a');
}
export const formatTime = date => {
    return dayjs(date).format('H : mm a');
}

export const formatDateTimeAddTime = (date, hours, seconds) => {
    let minutes = hours ? hours * 60 :  0 * 60
    var dateNew = dayjs(date)
        .add(seconds ? seconds : 0, 'seconds')
        .add(minutes ? minutes : 0, 'minutes')
        return dayjs(dateNew).format('MM/DD/YYYY  hh:mm:ss a');
    // return dayjs(dateNew).format('YYYY-MM-DD  hh:mm:ss a');
}

export const DateCheckTime = (completionDates, timeZoneOffset = "", isFormatSite=false, dataToday=new Date()) => {
    const completionDate = isFormatSite || !timeZoneOffset ? dayjs(completionDates).utcOffset(isFormatSite ?"" : timeZoneOffset) : dayjs(completionDates).tz(isFormatSite ?"" : timeZoneOffset)
    if(checkTimeZone(timeZoneOffset)) return;
    const currentDate = timeZoneOffset ? dayjs(dataToday).tz(timeZoneOffset).format('YYYY-MM-DD  HH:mm:ss') : dayjs(dataToday).utcOffset(timeZoneOffset).format('YYYY-MM-DD  HH:mm:ss')
    const isToday = completionDate.isSame(currentDate, "day");
    return isToday;
};

export const getDateByZone = (date) => {
    let user = store.getState().userInfStateReducer;
    let siteIdCurrent = user && user.userInfo && user.userInfo.siteIdCurrent ? user.userInfo.siteIdCurrent : null
    let timeZoneOffset = siteIdCurrent && siteIdCurrent.timeZone ? siteIdCurrent.timeZone : "";
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset)
    return timeDate.format('YYYY-MM-DD  hh:mm:ss a')
}

export const DateCheckTimeGet = (completionDates, isFormat) => {
    let user = store.getState().userInfStateReducer;
    let siteIdCurrent = user && user.userInfo && user.userInfo.siteIdCurrent ? user.userInfo.siteIdCurrent : null
    let timeZoneOffset = siteIdCurrent && siteIdCurrent.timeZone ? siteIdCurrent.timeZone : "";
    if(checkTimeZone(timeZoneOffset)) return;
        
    const completionDate = timeZoneOffset ? dayjs(completionDates).tz(timeZoneOffset) : dayjs(completionDates).utcOffset(timeZoneOffset)
    const currentDate = timeZoneOffset ? dayjs(new Date()).tz(timeZoneOffset) : dayjs(new Date()).utcOffset(timeZoneOffset)
    return completionDate
    const isToday = completionDate.isSame(currentDate, "day");
    return isToday;
};


export const setIsDetectLoad = (status) => {
    store.dispatch({type: IS_DETECT_LOADING, isDetectLoading: status});
    localStorage.setItem("isDetectLoad", status)
};

export const isCheckIsDetectLoad = () => {
    let isDetectLoad = store.getState().isDetectLoadingState?.isDetectLoading;
    let isDetectLoadLocal = localStorage.getItem(`isDetectLoad`)
    return isDetectLoadLocal ? isDetectLoadLocal : false
};

export const formatDateCenterMMDD = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset);
    return timeDate.format('MM/DD');
};

export const formatDateCenterMMDDYYYY = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset);
    return timeDate.format('MM/DD/YYYY');
};

export const formatDateCenterMMDDYYYYTime = (date, timeZoneOffset) => {
    if(checkTimeZone(timeZoneOffset)) return;
    const timeDate = timeZoneOffset ? dayjs(date).tz(timeZoneOffset) : dayjs(date).utcOffset(timeZoneOffset);
    return timeDate.format('MM/DD/YYYY h:mm a');
};

export const formatDateTimeSlasNoSpaceMMDDYYUpperCaseTime = (date, timeZoneOffset) => {
    const timeDate = dayjs(date).utcOffset(timeZoneOffset)
    return (
        <>
        <span>{timeDate.format('MM/DD/YYYY')}</span>&nbsp;&nbsp;
        <span>{timeDate.format('h:mm a').toUpperCase()}</span>
        </>
    )
}